import * as Factory from 'factory.ts'

import { type VendorPaymentMethodApiModel } from '../VendorPaymentMethodApiModel'

export const VendorPaymentMethodApiModelStub =
  Factory.Sync.makeFactory<VendorPaymentMethodApiModel>({
    id: Factory.each((i) => i + 1),
    name: Factory.each((i) => `Payment method ${i + 1}`),
    currency: { id: 1 },
  })
